import { useMatchRoute, useRouterState } from "@tanstack/react-router";

export const useIsCircleAiPageRoute = () => {
  const matchRoute = useMatchRoute();

  const isAiIndexRoute = Boolean(matchRoute({ to: "/ai" }));
  const isAiConversationRoute = useRouterState({
    select: state =>
      state.matches.some(
        match => match.routeId === "/_protected/ai/$conversationId",
      ),
  });
  const isAiProjectsRoute = Boolean(
    matchRoute({ to: "/ai/projects", fuzzy: true }),
  );
  const isAiRoute = Boolean(matchRoute({ to: "/ai", fuzzy: true }));
  // A single daily brief is an immersive read, so it owns the canvas like the
  // index and conversation routes (the Briefs list at /ai/briefs does not).
  const isAiDailyBriefDetailRoute = useRouterState({
    select: state =>
      state.matches.some(
        match => match.routeId === "/_protected/ai/daily-briefs/$dailyBriefId",
      ),
  });
  // Only the index, conversation, and daily brief detail routes own the canvas;
  // fuzzy AI routes such as skills and projects keep the side panel available.
  const isFullPageAiRoute =
    isAiIndexRoute || isAiConversationRoute || isAiDailyBriefDetailRoute;

  return {
    isAiRoute,
    isAiConversationRoute,
    isFullPageAiRoute,
    isAiIndexRoute,
    isAiProjectsRoute,
  };
};
